module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-3.e79b97a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-3.jpg
// module id = YYCI
// module chunks = 1